import {
    Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    TextField,
} from '@mui/material';
import React, { useContext, useState } from 'react';
import { boxStyle } from '../../Pages/Projects/styles';
import { addWeekCall } from '../../Services/APICalls/apicalls';
import { IContextData } from '../../../App';
import { StateContext, Link } from '../../StateContext';
import { MechanicHourValue } from '../../Services/types';
import { useLanguage } from '../../Services/LanguageContext';

interface IProps {
    link?: Link;
    defaultTypeId?: number | null;
}

export const hourToSeconds = (hoursWorked) => {
    return hoursWorked * 3600;
};

const AddWeekOverview = (props: IProps) => {
    const { loginData, setLoginData } = useContext<IContextData>(StateContext);
    const { t } = useLanguage();

    const currentMechanic = loginData.mechanics.find(
        (x) => x.id === props.link.mechanicId
    );
    const project = loginData.projects.find((p) => p.id === props.link.projectId);
    const projectTypes = project?.types ?? [];

    const [hourWeight, setHourWeight] = useState<string | number>(
        currentMechanic.defaultWeight
    );
    const [open, setOpen] = useState(false);
    const [weekNumber, setWeekNumber] = useState(0);
    const [hoursWorked, setHoursWorked] = useState(0);
    const [year, setYear] = useState(new Date().getFullYear());
    const [projectTypeId, setProjectTypeId] = useState<number | ''>(props.defaultTypeId ?? '');

    const addWeekHandler = (e?: React.FormEvent) => {
        e?.preventDefault();
        const secondsWorked = hourToSeconds(hoursWorked);
        addWeekCall(
            props.link.id,
            weekNumber,
            secondsWorked,
            hourWeight,
            year,
            setLoginData,
            projectTypeId === '' ? null : projectTypeId
        );
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button
                variant='contained'
                color='success'
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen(true);
                }}
            >
                {t('addWeek')}
            </Button>
            <Modal
                open={open}
                onClick={(x) => x.stopPropagation()}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box style={boxStyle}>
                    <form
                        action='#'
                        onSubmit={addWeekHandler}
                        className='flex flex-col items-center gap-3'
                    >
                        <div>
                            <TextField
                                type='number'
                                label={t('weekNumber')}
                                autoFocus
                                onClick={(x) => x.stopPropagation()}
                                onChange={(x) => setWeekNumber(parseInt(x.target.value))}
                            />
                        </div>
                        <div>
                            <TextField
                                type='number'
                                label={t('hours')}
                                inputProps={{ maxLength: 13, step: '0.01' }}
                                onClick={(x) => x.stopPropagation()}
                                onChange={(x) =>
                                    setHoursWorked(parseFloat(x.target.value.replace(',', '.')))
                                }
                            />
                        </div>
                        <div>
                            <TextField
                                type='number'
                                label={t('year')}
                                value={year}
                                onClick={(x) => x.stopPropagation()}
                                onChange={(x) => setYear(parseInt(x.target.value))}
                            />
                        </div>
                        <div>
                            <FormControl style={{ width: '220px' }}>
                                <InputLabel id='mechanic-type-select-label'>
                                    {t('type')}
                                </InputLabel>
                                <Select
                                    label={t('type')}
                                    labelId='mechanic-type-select-label'
                                    id='mechanic-type-select'
                                    value={hourWeight}
                                    onChange={(x) => setHourWeight(x.target.value)}
                                >
                                    {MechanicHourValue.map((type) => (
                                        <MenuItem key={type.value} value={type.value}>
                                            {type.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                        {projectTypes.length > 0 && (
                            <div>
                                <FormControl style={{ width: '220px' }}>
                                    <InputLabel id='project-type-select-label'>
                                        {t('workType')}
                                    </InputLabel>
                                    <Select
                                        label={t('workType')}
                                        labelId='project-type-select-label'
                                        id='project-type-select'
                                        value={projectTypeId}
                                        onChange={(x) => setProjectTypeId(x.target.value as number | '')}
                                    >
                                        <MenuItem value=''>{t('noType')}</MenuItem>
                                        {projectTypes.map((pt) => (
                                            <MenuItem key={pt.id} value={pt.id}>
                                                {pt.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        )}
                        <button style={{ width: '220px' }}>{t('add')}</button>
                    </form>
                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default AddWeekOverview;
